import React from "react";
import {
  Tabs,
  Tab,
  Spinner,
  OverlayTrigger,
  Tooltip,
  Button,
} from "react-bootstrap";
import Header from "../../Common/Header";
import "./ViewMentorProfile.scss";
import Footer from "../../Common/Footer/Footer";
import Profile from "./Profile";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faCircleInfo,
  faCloudArrowDown,
  faStar,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { getRating } from "../../../_helpers/getRating";
import useViewMentorProfile from "./useViewMentorProfile";
import { Document, Page, pdfjs } from "react-pdf";
import Evaluation from "./Evaluation";
import { Modal } from "react-bootstrap";
import MainLayout from "../../Common/MainLayout";
import CustomImage from "../../Common/CustomImage";
import CustomPdfViewer from "../../Common/CustomPdfViewer";
import useCopyToClipboard from "../../../_hooks/useCopyToClipboard";

function ViewMentorProfile(props) {
  const {
    userData,
    userPrimarySkills,
    onScheduleInterviewClick,
    onNavigateBack,
    onShareProfileClick,
    publicEvents,
  } = useViewMentorProfile(props);


  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  return (
    <MainLayout pageName={"Mentor Profile"}>
      <div className="">
        <div className="container flex-wrap d-flex justify-content-between align-items-center">
          <h2 className="text-capitalize">
            {userData?.mentor_profile_details &&
              userData.mentor_profile_details?.user_details &&
              userData.mentor_profile_details.user_details?.full_name}
          </h2>
          <div className="d-flex">
            <div className="share d-flex">
              <button
                className="btn btn-light mr-2 d-flex"
                onClick={onShareProfileClick}
              >
                <CustomImage
                  src="/assets/images/share-icon.svg"
                  height={"20px"}
                  width={"20px"}
                  className="pr-2"
                />
                <span className="ml-1">Share</span>
              </button>
            </div>
            {publicEvents ? (
              <div className="action">
                <button
                  className="btn btn-primary d-flex"
                  onClick={onScheduleInterviewClick}
                >
                  <CustomImage
                    src="/assets/images/light-calendar.svg"
                    height={"20px"}
                    width={"20px"}
                    className="mr-2"
                  />
                  <span className="ml-1">Schedule Interview</span>
                </button>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <div className="hiring-process-dashboard footer-gap w-100">
        <div className="hiring-board mt-3">
          <div className="container">
            <div className="row pr-1 no-gutters">
              <div className="candidate-info-sidebar bg-white border border-radius-10 col-lg-3">
                <div className="p-3">
                  <div className="mb-2 w-100 d-flex align-items-center text-lg-center text-xl-left flex-lg-column flex-xl-row">
                    <div className="candidate-img mw-100 rounded-lg">
                      <img
                        src={
                          userData?.mentor_details &&
                            userData.mentor_details?.user_meta_info &&
                            userData.mentor_details.user_meta_info?.profile_image
                            ? userData?.mentor_details &&
                            userData.mentor_details?.user_meta_info &&
                            userData.mentor_details.user_meta_info
                              ?.profile_image
                            : " /assets/images/user.png"
                        }
                        alt="candidate img "
                        className="profile-image"
                      />
                    </div>
                    <div className="candidate-quick-info ml-3">
                      <h3 className="text-capitalize">
                        {userData?.mentor_profile_details &&
                          userData.mentor_profile_details?.user_details &&
                          userData.mentor_profile_details.user_details
                            ?.full_name}
                      </h3>
                      <p className="text-capitalize text-grey-4 pt-2">
                          {userData?.mentor_profile_details && userData.mentor_profile_details?.headline}
                        </p>
                    </div>
                  </div>
                  {Array.isArray(userData?.mentor_profile_details && userData.mentor_profile_details?.skills) &&
                    userData?.mentor_profile_details && userData.mentor_profile_details?.skills.length !== 0 ? (
                    <span className="font-weight-medium my-3 d-inline-block bg-grey-3 rounded-pill pl-2 pr-1 py-1 border text-lg-center text-xl-left">
                      Overall Rating
                      <OverlayTrigger
                        overlay={<Tooltip>self evaluated skills</Tooltip>}
                      >
                        <Button
                          variant="white"
                          className="p-0 text-warning"
                        >
                          <span className="overall-rating p-2 rounded-pill custom-tag tag-offer ml-2">
                            <FontAwesomeIcon
                              icon={faStar}
                              className="mr-1"
                            />
                            <span className="text-danger fs-14">
                              {userData?.mentor_profile_details && userData.mentor_profile_details?.skills &&
                                getRating(userData?.mentor_profile_details && userData.mentor_profile_details?.skills)}
                            </span>
                          </span>
                        </Button>
                      </OverlayTrigger>
                    </span>
                  ) : null}
                </div>

                {/* evaluation list  */}
                <div className="evaluation-list border-top pt-2 d-none d-lg-block">
                  {Array.isArray(userPrimarySkills) &&
                    userPrimarySkills.map((item) => (
                      <div className="" key={item?.id}>
                        {/* evaluation box  */}
                        <div className="evaluation-box py-3 px-2 bg-white rounded shadow-sm mb-2">
                          <div className="d-flex align-items-center justify-content-between">
                            <p className="text-capitalize fs-14 bg-grey rounded px-1">
                              {item?.skill_name}
                            </p>
                            <span className="d-inline-block border rounded text-primary px-2">
                              <FontAwesomeIcon
                                icon={faStar}
                                className="mr-2 text-warning"
                              />
                              {item?.rating}
                            </span>
                          </div>
                          <ul className="d-flex evaluation-ratings align-items-center mt-3">
                            {item?.rating
                              ? [...Array(item?.rating).keys()].map(() => (
                                <li className="bg-light">
                                  <span
                                    className="d-inline-block bg-primary h-100"
                                    style={{ width: "100%" }}
                                  ></span>
                                </li>
                              ))
                              : null}
                            {[...Array(5 - item?.rating).keys()].map((i) => (
                              <li className="bg-light">
                                <span
                                  className="d-inline-block bg-primary h-100"
                                  style={{ width: "0%" }}
                                ></span>
                              </li>
                            ))}
                          </ul>
                        </div>

                        {/* evaluation box ends */}
                      </div>
                    ))}
                </div>
                {/* evaluation box ends */}
              </div>
              {/* applied applied info  */}
              <div className="col-lg-9">
                <div className="panel-right pt-3">
                  <Tabs
                    defaultActiveKey="MentorProfile"
                    className="border-bottom ml-4"
                  >
                    <Tab eventKey="MentorProfile" title="Profile">
                      <div className="tab-inner p-4">
                        <Profile />
                      </div>
                    </Tab>
                    <Tab eventKey="Resume" title="Resume">
                      <div className="tab-inner p-4 d-flex justify-content-center align-items-center">
                        {userData?.mentor_details &&
                          userData.mentor_details?.user_meta_info &&
                          userData.mentor_details.user_meta_info?.resume ===
                          null ? (
                          <img
                            src="/assets/images/resume-template.png"
                            className="w-100"
                            alt="resume template"
                          />
                        ) : (
                          <div className="bg-white border border-radius-10 p-4 w-100">
                            <div className="text-right">
                              <a
                                className="btn btn-light mb-3"
                                href={`${userData?.mentor_details &&
                                  userData.mentor_details?.user_meta_info &&
                                  userData.mentor_details.user_meta_info?.resume
                                  }`}
                                download
                                target="_blank"
                              >
                                <FontAwesomeIcon
                                  icon={faCloudArrowDown}
                                  className="mr-2"
                                />
                                Download
                              </a>
                            </div>
                            <CustomPdfViewer
                              file={
                                userData?.mentor_details &&
                                userData.mentor_details?.user_meta_info &&
                                userData.mentor_details.user_meta_info?.resume
                              }
                            />
                          </div>
                        )}
                      </div>
                    </Tab>
                    <Tab eventKey="Evaluation" title="Evaluation">
                      <div className="tab-inner p-2">
                        <Evaluation
                          userPrimarySkills={userPrimarySkills}
                          overallRatings={
                            userData?.mentor_profile_details &&
                            userData.mentor_profile_details?.skills &&
                            getRating(
                              userData &&
                              userData?.mentor_profile_details &&
                              userData.mentor_profile_details?.skills
                            )
                          }
                        />
                      </div>
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
export default ViewMentorProfile;
